import { MATH_PHYSICS_TOPICS } from './studyToolTopicsMathPhysics';
import { CHEMISTRY_TOPICS } from './studyToolTopicsChemistry';
import { BIOLOGY_TOPICS } from './studyToolTopicsBiology';
import { EARTH_TOPICS } from './studyToolTopicsEarth';
import type { StudyTool } from './studyToolTypes';

export const STUDY_TOOL_TOPICS = [
  ...MATH_PHYSICS_TOPICS,
  ...CHEMISTRY_TOPICS,
  ...BIOLOGY_TOPICS,
  ...EARTH_TOPICS,
];
const fraction = STUDY_TOOL_TOPICS.find((rule) => rule.id === 'fraction-ratio-lab')!;
fraction.terms = new RegExp(`${fraction.terms.source}|\\b\\d+\\s*/\\s*\\d+\\b`, 'i');

/** A mapping does not promote an unreviewed Explore candidate into a recommended tool. */
export function isRecommendationPreview(tool: StudyTool) {
  return (
    tool.category === 'senior-experiments' ||
    /candidate/i.test(tool.yearLabel ?? '') ||
    tool.id === 'earth-energy-budget' ||
    tool.id === 'physics-lab'
  );
}
export function toolTopicCoverage(tools: StudyTool[]) {
  const mapped = new Set(STUDY_TOOL_TOPICS.map((rule) => rule.id));
  return {
    registered: tools.length,
    covered: tools.filter((tool) => mapped.has(tool.id)).length,
    preview: tools.filter(isRecommendationPreview).map((tool) => tool.id),
    missing: tools.filter((tool) => !mapped.has(tool.id)).map((tool) => tool.id),
  };
}
